import { render } from "./corporateDetails.vue?vue&type=template&id=c4790fdc&scoped=true"
import script from "./corporateDetails.vue?vue&type=script&lang=js"
export * from "./corporateDetails.vue?vue&type=script&lang=js"

import "./corporateDetails.vue?vue&type=style&index=0&id=c4790fdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4790fdc"]])

export default __exports__